// extracted by mini-css-extract-plugin
module.exports = {"label":"_2Ly4jB3akZUOCsDJvddKKS","wrapper":"_2v2ghUF5g5IsJZ7E4vMMGG","input":"_171Iwt0rzG5I2ma2xCxCWw","tab":"-DIPEGgo5BQOPV4bewbQK"};